// Copyright ©️ 2026 eVolve MEP, LLC

import type { CustomPropertyDataTypeMap } from '@evolvemep/api-ts';

import type { EvolveIconProps } from 'assets/icons/EvolveIcon';

export const dataTypeIconMap: Record<keyof CustomPropertyDataTypeMap, Pick<EvolveIconProps, 'icon' | 'color'>> = {
  text: { icon: 'TextProperty', color: 'indigo.7' },
  date: { icon: 'DateProperty', color: 'cyan.7' },
  dropdown: { icon: 'DropdownProperty', color: 'orange' },
  number: { icon: 'NumberProperty', color: 'pink' },
  toggle: { icon: 'ToggleProperty', color: 'teal' },
};

export const dataTypeLabelMap: Record<keyof CustomPropertyDataTypeMap, string> = {
  text: 'Text',
  date: 'Date',
  dropdown: 'Dropdown selection',
  number: 'Number',
  toggle: 'Toggle',
};

export const allDataTypes = Object.keys(dataTypeLabelMap) as (keyof CustomPropertyDataTypeMap)[];
